module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/loading/loading.component.css
// module id = ./src/app/examples/loading/loading.component.css
// module chunks = main